import React from 'react'
import CardOne from '../common/card/CardOne'

interface IReportDetailGridBoxProps {
  title: string
  contentText?: string
  content?: React.ReactNode
  isList?: boolean
}

const ReportDetailGridBox = ({ title, contentText, content, isList = false }: IReportDetailGridBoxProps) => {
  const renderContent = () => {
    if (!contentText) return null

    if (isList) {
      const items = contentText.split('\n').filter(item => item.trim())
      return (
        <ul className='text-gray-700 leading-relaxed text-sm list-disc list-inside space-y-1'>
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      )
    }

    return <p className='text-gray-700 leading-relaxed text-sm whitespace-pre-line'>{contentText}</p>
  }

  return (
    <>
      <CardOne className=' shadow-sm'>
        <h3 className='text-sm font-bold text-gray-800 mb-2'>{title}</h3>
        {content}
        {renderContent()}
      </CardOne>
    </>
  )
}

export default ReportDetailGridBox
